// extracted by mini-css-extract-plugin
export default {"heading":"Kt-z","corrected":"Lt-z","redirectVerbiageContainer":"Mt-z","redirectVerbiageText":"Nt-z"};